// extracted by mini-css-extract-plugin
module.exports = {"text":"OpenButton_text__1-fqM","contained":"OpenButton_contained__18kjP","disabled":"OpenButton_disabled__2NAjq","error":"OpenButton_error__2fQom"};